import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Card from "@mui/material/Card";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import MDBox from "components/MDBox";
import MDEditor from "components/MDEditor";
import MDDatePicker from "components/MDDatePicker";
import MDTypography from "components/MDTypography";
import Autocomplete from "@mui/material/Autocomplete";
import {
    Grid,
    CircularProgress,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
} from "@mui/material";
import Switch from "@mui/material/Switch";

import MapSelect from "./map/index";
import config from "../../../../config";
import MDSnackbar from "components/MDSnackbar";

const AccidentDetails = () => {
    const { id } = useParams();
    const navigate = useNavigate(); // <--- add this

    const [type, setType] = useState("");
    const [severity, setSeverity] = useState("");
    const [weather, setWeather] = useState("");
    const [roadStatus, setRoadStatus] = useState("");
    const [description, setDescription] = useState("");
    const [tseoi, setTseoi] = useState("");
    const [timerange, setTimeRange] = useState("");
    const [position, setPosition] = useState(null); // [lon, lat]
    const [island, setIsland] = useState("");

    const [selectedCounts, setSelectedCounts] = useState({});
    const [selectedInjured, setSelectedInjured] = useState({});
    const [selectedViolations, setSelectedViolations] = useState({});

    const [loading, setLoading] = useState(true);
    const [fetchError, setFetchError] = useState(null);

    const [isEditing, setIsEditing] = useState(false);

    const [successSB, setSuccessSB] = useState(false);
    const [errorSB, setErrorSB] = useState(false);

    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);

    const openSuccessSB = () => setSuccessSB(true);
    const closeSuccessSB = () => setSuccessSB(false);
    const openErrorSB = () => setErrorSB(true);
    const closeErrorSB = () => setErrorSB(false);

    const API_TOKEN = config.MAP_MATCHING_API_TOKEN;
    const API_URL = config.MAP_MATCHING_API_URL;

    function bringSuccessNotification() {
        return (
            <MDSnackbar
                color="success"
                icon="check"
                title="Ατυχήματα Ειδοποίηση"
                content="Επιτυχής ενημέρωση ατυχήματος"
                dateTime={new Date().toLocaleTimeString()}
                open={successSB}
                onClose={closeSuccessSB}
                close={closeSuccessSB}
                bgWhite
            />
        );
    }

    function bringErrorNotification() {
        return (
            <MDSnackbar
                color="error"
                icon="warning"
                title="Ατυχήματα Ειδοποίηση"
                content="Προέκυψε σφάλμα"
                dateTime={new Date().toLocaleTimeString()}
                open={errorSB}
                onClose={closeErrorSB}
                close={closeErrorSB}
                bgWhite
            />
        );
    }

    const islandTypes = [
        { id: 1, name: "Ρόδος" },
        { id: 2, name: "Κως" },
        { id: 3, name: "Κάλυμνος" },
        { id: 4, name: "Λέρος" },
        { id: 5, name: "Κάρπαθος" },
        { id: 6, name: "Κάσος" },
        { id: 7, name: "Πάτμος" },
        { id: 8, name: "Αστυπάλαια" },
        { id: 9, name: "Νίσυρος" },
        { id: 10, name: "Τήλος" },
        { id: 11, name: "Σύμη" },
        { id: 12, name: "Χάλκη" },
        { id: 13, name: "Λειψοί" },
        { id: 14, name: "Μεγίστη" },
        { id: 15, name: "Αγαθονήσι" },
        { id: 16, name: "Σύρος" },
    ];

    const accidentTypes = [
        { id: 1, name: "Σύγκρουση σε προπορευόμενο όχημα" },
        { id: 2, name: "Μετωπική σύγκρουση" },
        { id: 3, name: "Πλαγιομετωπική σύγκρουση" },
        { id: 4, name: "Πλάγια σύγκρουση" },
        { id: 5, name: "Πρόσκρουση σε σταθμευμένο όχημα" },
        { id: 6, name: "Εκτροπή οχήματος" },
        { id: 7, name: "Ανατροπή οχήματος" },
        { id: 8, name: "Παράσυρση πεζού" },
        { id: 9, name: "Σύγκρουση με ζώο" },
        { id: 10, name: "Άλλο" },
    ];

    const severityVals = [
        { id: 1, name: "Χαμηλή" },
        { id: 2, name: "Μέτρια" },
        { id: 3, name: "Υψηλή" },
    ];

    const weatherVals = [
        { id: 1, name: "Χωρίς ιδιαίτερες καιρικές συνθήκες" },
        { id: 2, name: "Βροχή" },
        { id: 3, name: "Καταιγίδα" },
        { id: 4, name: "Χαλάζι" },
        { id: 5, name: "Χιονόπτωση" },
        { id: 6, name: "Ομίχλη" },
        { id: 7, name: "Άλλο" },
    ];

    const roadStatusVals = [
        { id: 1, name: "Στεγνό" },
        { id: 2, name: "Υγρό" },
        { id: 3, name: "Λάδια" },
        { id: 4, name: "Χαλίκι" },
        { id: 5, name: "Πάγος" },
        { id: 6, name: "Γλίτσα" },
        { id: 7, name: "Άλλο" },
    ];

    const vehicleTypes = [
        { id: 1, name: "Βαρέα οχήματα & Επαγγελματικά οχήματα > 3,5 τ " },
        { id: 2, name: "Δίκυκλα" },
        { id: 3, name: "Ενοικιαζόμενα" },
        { id: 4, name: "Επαγγελματικά επιβατικά & Επαγγελματικά οχήματα < 3,5 τ " },
        { id: 5, name: "Ποδήλατα" },
        { id: 6, name: "Πεζοί" },
        { id: 7, name: "Ηλεκτρικά πατίνια" },
        { id: 8, name: "Επιβατικό Ι.Χ." },
        { id: 9, name: "Λοιπά οχήματα" },
    ];

    const violationLabels = [
        { id: 1, name: "Διαπιστωμένη υπέρβαση του ορίου ταχύτητας" },
        { id: 2, name: "Αριστερή στροφή σε διπλή διαχωριστική γραμμή" },
        { id: 3, name: "Παραβίαση STOP/Φωτ. σηματοδότη" },
        { id: 4, name: "Παράνομη στάθμευση" },
        { id: 5, name: "Αντικανονικό προσπέρασμα" },
        { id: 6, name: "Επικίνδυνοι ελιγμοί" },
        { id: 7, name: "Παραβίαση προτεραιότητας σε κόμβο" },
        { id: 10, name: "Οδήγηση χωρίς τη νόμιμη άδεια οδήγησης" },
        { id: 9, name: "Οδήγηση υπό την επίδραση αλκοόλ" },
        { id: 8, name: "Παράνομη αναστροφή" },
    ];

    const injuredTypes = [
        { id: 1, name: "Ελαφρά τραυματίες" },
        { id: 2, name: "Βαριά τραυματίες" },
        { id: 3, name: "Νεκροί" },
    ];

    const handleInputChange = (field, value) => {
        if (!isEditing) return;

        if (field === "type_accident") {
            setType(value?.id ?? "");
        } else if (field === "island") {
            setIsland(value?.id ?? "");
        } else if (field === "weather") {
            setWeather(value?.id ?? "");
        } else if (field === "road") {
            setRoadStatus(value?.id ?? "");
        } else if (field === "tseoi") {
            setTseoi(value.target.value);
        } else if (field === "description") {
            requestAnimationFrame(() => {
                setDescription(value);
            });
        } else {
            console.error("Unknown field: ", field);
        }
    };

    const handleChange = (vehicleId, value) => {
        if (!isEditing) return;
        setSelectedCounts((prev) => ({
            ...prev,
            [vehicleId]: value === "" ? "" : Math.max(0, parseInt(value) || 0),
        }));
    };

    const handleChangeInjured = (injuredId, value) => {
        if (!isEditing) return;
        setSelectedInjured((prev) => ({
            ...prev,
            [injuredId]: value === "" ? "" : Math.max(0, parseInt(value) || 0),
        }));
    };

    const handleViolationChange = (labelId, value) => {
        if (!isEditing) return;
        setSelectedViolations((prev) => ({
            ...prev,
            [labelId]: value,
        }));
    };

    const handleDateChange = (date, field) => {
        if (!isEditing) return;
        if (date && date[0]) {
            setTimeRange(date[0].toISOString());
        }
    };

    function transformAccidentData(data) {
        return {
            ...data,
            involved: Object.entries(data.involved || {}).map(([id, value]) => ({
                id: Number(id),
                value,
            })),
            injured: Object.entries(data.injured || {}).map(([id, value]) => ({
                id: Number(id),
                value,
            })),
            violations: Object.entries(data.violations || {})
                .filter(([_, isTrue]) => isTrue)
                .map(([id]) => Number(id)),
        };
    }

    // ---- FETCH ACCIDENT BY ID ----
    useEffect(() => {
        const fetchAccident = async () => {
            try {
                setLoading(true);
                setFetchError(null);

                const url = `${API_URL}/accidents/${id}`;
                const response = await axios.get(url, {
                    headers: {
                        "X-API-Key": API_TOKEN,
                        accept: "*/*",
                    },
                });

                const acc = response.data;

                setIsland(acc.island ?? "");
                setType(acc.type_accident ?? "");
                setWeather(acc.weather ?? "");
                setRoadStatus(acc.road ?? "");
                setDescription(acc.description ?? "");
                setTimeRange(acc.date ?? "");
                setSeverity(acc.severity ?? "");
                setTseoi(acc.tseoi ?? "");

                // Backend position is [lon, lat]; local state also [lon, lat]
                if (acc.position && acc.position.length === 2) {
                    setPosition(acc.position);
                }

                const counts = {};
                (acc.involved || []).forEach((item) => {
                    counts[item.id] = item.value;
                });
                setSelectedCounts(counts);

                const injuredMap = {};
                (acc.injured || []).forEach((item) => {
                    injuredMap[item.id] = item.value;
                });
                setSelectedInjured(injuredMap);

                const violationsMap = {};
                (acc.violations || []).forEach((vId) => {
                    violationsMap[vId] = true;
                });
                setSelectedViolations(violationsMap);
            } catch (error) {
                console.error(error);
                setFetchError("Αποτυχία φόρτωσης του ατυχήματος");
                openErrorSB();
            } finally {
                setLoading(false);
            }
        };

        if (id) {
            fetchAccident();
        }
    }, [id]);

    // ---- UPDATE (SAVE EDIT) HANDLER ----
    const handleUpdate = async () => {
        if (!id) return;

        const data = {
            id: Number(id),
            island: island,
            type_accident: type,
            weather: weather,
            road: roadStatus,
            description: description,
            date: timerange,
            position: position ? position.reverse() : null, // [lon, lat] for backend
            involved: selectedCounts,
            violations: selectedViolations,
            injured: selectedInjured,
            severity: severity || 1,
            tseoi: tseoi,
        };

        const dataToSend = transformAccidentData(data);
        console.log("Update payload:", dataToSend);

        try {
            const url = `${API_URL}/accidents/${id}`;
            await axios.put(url, dataToSend, {
                headers: {
                    "X-API-Key": API_TOKEN,
                    "Content-Type": "application/json",
                },
            });

            openSuccessSB();
            setIsEditing(false);
        } catch (error) {
            console.error(error);
            openErrorSB();
        }
    };





    // ---- DELETE HANDLERS (with confirmation modal) ----
    const handleDeleteClick = () => {
        setOpenDeleteDialog(true);
    };

    const handleDeleteCancel = () => {
        setOpenDeleteDialog(false);
    };

    const handleDeleteConfirmed = async () => {
        if (!id) return;

        try {
            const url = `${API_URL}/accidents/${id}`;

            await axios.delete(url, {
                headers: {
                    "X-API-Key": API_TOKEN,
                    accept: "*/*",
                },
            });

            setOpenDeleteDialog(false);
            openSuccessSB();

            // Optional: redirect back to list page after a short delay
            setTimeout(() => {
                // change this path to whatever your listing route is
                navigate("/list/accidents");
            }, 1500);
        } catch (error) {
            console.error(error);
            setOpenDeleteDialog(false);
            openErrorSB();
        }
    };

    if (loading) {
        return (
            <DashboardLayout>
                <MDBox mt={4} display="flex" justifyContent="center" alignItems="center">
                    <CircularProgress />
                </MDBox>
            </DashboardLayout>
        );
    }

    if (fetchError) {
        return (
            <DashboardLayout>
                <MDBox mt={4} display="flex" justifyContent="center" alignItems="center">
                    <MDTypography color="error">{fetchError}</MDTypography>
                    {bringErrorNotification()}
                </MDBox>
            </DashboardLayout>
        );
    }

    return (
        <DashboardLayout>
            <MDBox mt={4} p={0}>
                <Grid container spacing={3}>
                    <Grid item xs={12} md={5}>
                        <Card id="accident-details-form" sx={{ overflow: "visible" }}>
                            <MDBox p={3}>
                                <MDTypography variant="h5">
                                    Προβολή / Επεξεργασία Ατυχήματος #{id}
                                </MDTypography>
                            </MDBox>

                            <MDBox component="form" pb={3} px={3}>
                                <Grid container spacing={3}>
                                    {/* Island */}
                                    <Grid item xs={12}>
                                        <MDTypography
                                            component="label"
                                            variant="button"
                                            fontWeight="regular"
                                            color="text"
                                        >
                                            Νησί στο οποίο έγινε το ατύχημα *
                                        </MDTypography>
                                        <Autocomplete
                                            readOnly={!isEditing}
                                            value={islandTypes.find((v) => v.id === island) || null}
                                            options={islandTypes}
                                            getOptionLabel={(option) => option.name}
                                            onChange={(e, selectedOption) =>
                                                handleInputChange("island", selectedOption)
                                            }
                                            renderInput={(params) => (
                                                <MDInput
                                                    {...params}
                                                    variant="standard"
                                                    inputProps={{
                                                        ...params.inputProps,
                                                        readOnly: !isEditing,
                                                    }}
                                                />
                                            )}
                                        />
                                    </Grid>

                                    {/* Date */}
                                    <Grid item xs={12} sm={6} container direction="column">
                                        <MDTypography
                                            component="label"
                                            variant="button"
                                            fontWeight="regular"
                                            color="text"
                                        >
                                            Ημερομηνία *
                                        </MDTypography>
                                        <MDDatePicker
                                            input={{
                                                placeholder: "dd/mm/yyyy HH:mm",
                                                readOnly: !isEditing,
                                            }}
                                            value={timerange ? new Date(timerange) : null}
                                            options={{
                                                enableTime: true,
                                                dateFormat: "d/m/Y H:i",
                                                altFormat: "d/m/Y H:i",
                                                time_24hr: true,
                                                clickOpens: isEditing,
                                            }}
                                            onChange={(date) => handleDateChange(date, "date")}
                                        />
                                    </Grid>

                                    {/* Position */}
                                    <Grid item xs={12} sm={12} container direction="column">
                                        <MDTypography
                                            component="label"
                                            variant="button"
                                            fontWeight="regular"
                                            color="text"
                                        >
                                            Θέση Ατυχήματος *
                                        </MDTypography>
                                        {!position && (
                                            <MDTypography
                                                component="label"
                                                variant="button"
                                                fontWeight="regular"
                                                color="text"
                                            >
                                                Επέλεξε Θέση στο Χάρτη
                                            </MDTypography>
                                        )}
                                        {position && (
                                            <>
                                                <MDTypography
                                                    component="label"
                                                    variant="button"
                                                    fontWeight="regular"
                                                    color="text"
                                                >
                                                    Lat: {position[1]}
                                                </MDTypography>
                                                <MDTypography
                                                    component="label"
                                                    variant="button"
                                                    fontWeight="regular"
                                                    color="text"
                                                >
                                                    Long: {position[0]}
                                                </MDTypography>
                                            </>
                                        )}
                                    </Grid>

                                    {/* Type of Accident */}
                                    <Grid item xs={12}>
                                        <MDTypography
                                            component="label"
                                            variant="button"
                                            fontWeight="regular"
                                            color="text"
                                        >
                                            Κατηγορία Ατυχήματος *
                                        </MDTypography>
                                        <Autocomplete
                                            readOnly={!isEditing}
                                            value={accidentTypes.find((vl) => vl.id === type) || null}
                                            options={accidentTypes}
                                            getOptionLabel={(option) => option.name}
                                            onChange={(e, selectedOption) =>
                                                handleInputChange("type_accident", selectedOption)
                                            }
                                            renderInput={(params) => (
                                                <MDInput
                                                    {...params}
                                                    variant="standard"
                                                    inputProps={{
                                                        ...params.inputProps,
                                                        readOnly: !isEditing,
                                                    }}
                                                />
                                            )}
                                        />
                                    </Grid>

                                    {/* Weather */}
                                    <Grid item xs={12}>
                                        <MDTypography
                                            component="label"
                                            variant="button"
                                            fontWeight="regular"
                                            color="text"
                                        >
                                            Κατάσταση Καιρού *
                                        </MDTypography>
                                        <Autocomplete
                                            readOnly={!isEditing}
                                            value={weatherVals.find((item) => item.id === weather) || null}
                                            options={weatherVals}
                                            getOptionLabel={(option) => option.name}
                                            onChange={(e, selectedOption) =>
                                                handleInputChange("weather", selectedOption)
                                            }
                                            renderInput={(params) => (
                                                <MDInput
                                                    {...params}
                                                    variant="standard"
                                                    inputProps={{
                                                        ...params.inputProps,
                                                        readOnly: !isEditing,
                                                    }}
                                                />
                                            )}
                                        />
                                    </Grid>

                                    {/* Road status */}
                                    <Grid item xs={12}>
                                        <MDTypography
                                            component="label"
                                            variant="button"
                                            fontWeight="regular"
                                            color="text"
                                        >
                                            Κατάσταση Δρόμου *
                                        </MDTypography>
                                        <Autocomplete
                                            readOnly={!isEditing}
                                            value={roadStatusVals.find((val) => val.id === roadStatus) || null}
                                            options={roadStatusVals}
                                            getOptionLabel={(option) => option.name}
                                            onChange={(e, selectedOption) =>
                                                handleInputChange("road", selectedOption)
                                            }
                                            renderInput={(params) => (
                                                <MDInput
                                                    {...params}
                                                    variant="standard"
                                                    inputProps={{
                                                        ...params.inputProps,
                                                        readOnly: !isEditing,
                                                    }}
                                                />
                                            )}
                                        />
                                    </Grid>

                                    {/* Involved */}
                                    <Grid item xs={12}>
                                        <MDBox mb={1}>
                                            <MDTypography
                                                component="label"
                                                variant="button"
                                                fontWeight="regular"
                                                color="text"
                                            >
                                                Καταχωρήστε το πλήθος των εμπλεκόμενων *
                                            </MDTypography>
                                        </MDBox>
                                        <MDBox display="grid" gridTemplateColumns={{ xs: "1fr" }} gap={2}>
                                            {vehicleTypes.map((vehicle) => (
                                                <MDBox key={vehicle.id} sx={{ minWidth: 170 }}>
                                                    <MDInput
                                                        type="number"
                                                        label={vehicle.name}
                                                        variant="standard"
                                                        value={selectedCounts[vehicle.id] ?? 0}
                                                        onChange={(e) =>
                                                            handleChange(vehicle.id, e.target.value)
                                                        }
                                                        fullWidth
                                                        inputProps={{
                                                            min: 0,
                                                            readOnly: !isEditing,
                                                        }}
                                                    />
                                                </MDBox>
                                            ))}
                                        </MDBox>
                                    </Grid>

                                    {/* Violations */}
                                    <Grid item xs={12}>
                                        <MDBox mb={1}>
                                            <MDTypography
                                                component="label"
                                                variant="button"
                                                fontWeight="regular"
                                                color="text"
                                            >
                                                Αίτια Ατυχήματος *
                                            </MDTypography>
                                        </MDBox>
                                        <MDBox
                                            display="grid"
                                            gridTemplateColumns={{
                                                xs: "1fr",
                                                sm: "repeat(2, 1fr)",
                                                lg: "repeat(3, 1fr)",
                                            }}
                                            gap={2}
                                        >
                                            {violationLabels.map((violation) => (
                                                <MDBox
                                                    key={violation.id}
                                                    sx={{
                                                        minWidth: 170,
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        alignItems: "center",
                                                        boxShadow: 2,
                                                        borderRadius: 2,
                                                    }}
                                                >
                                                    <MDTypography
                                                        variant="button"
                                                        fontWeight="regular"
                                                        sx={{ mb: 1, textAlign: "center" }}
                                                    >
                                                        {violation.name}
                                                    </MDTypography>
                                                    <Switch
                                                        checked={!!selectedViolations[violation.id]}
                                                        onChange={(e) =>
                                                            handleViolationChange(
                                                                violation.id,
                                                                e.target.checked
                                                            )
                                                        }
                                                        disabled={!isEditing}
                                                    />
                                                </MDBox>
                                            ))}
                                        </MDBox>
                                    </Grid>

                                    {/* Injured */}
                                    <Grid item xs={12}>
                                        <MDBox mb={1}>
                                            <MDTypography
                                                component="label"
                                                variant="button"
                                                fontWeight="regular"
                                                color="text"
                                            >
                                                Καταχωρήστε το πλήθος των παθόντων *
                                            </MDTypography>
                                        </MDBox>
                                        <MDBox
                                            display="grid"
                                            gridTemplateColumns={{ xs: "1fr", lg: "repeat(3, 1fr)" }}
                                            gap={2}
                                        >
                                            {injuredTypes.map((item) => (
                                                <MDBox key={item.id} sx={{ minWidth: 170 }}>
                                                    <MDInput
                                                        type="number"
                                                        label={item.name}
                                                        variant="standard"
                                                        value={selectedInjured[item.id] ?? 0}
                                                        onChange={(e) =>
                                                            handleChangeInjured(item.id, e.target.value)
                                                        }
                                                        fullWidth
                                                        inputProps={{
                                                            min: 0,
                                                            readOnly: !isEditing,
                                                        }}
                                                    />
                                                </MDBox>
                                            ))}
                                        </MDBox>
                                    </Grid>

                                    {/* TSEOI */}
                                    <Grid item xs={12}>
                                        <MDBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                            <MDTypography
                                                component="label"
                                                variant="button"
                                                fontWeight="regular"
                                                color="text"
                                            >
                                                Αναγνωριστικός Αριθμός Τροχαίας
                                            </MDTypography>
                                        </MDBox>
                                        <MDInput
                                            fullWidth
                                            type="text"
                                            value={tseoi || ""}
                                            onChange={(e) => handleInputChange("tseoi", e)}
                                            inputProps={{
                                                readOnly: !isEditing,
                                            }}
                                        />
                                    </Grid>

                                    {/* Description */}
                                    <Grid item xs={12}>
                                        <MDBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                            <MDTypography
                                                component="label"
                                                variant="button"
                                                fontWeight="regular"
                                                color="text"
                                            >
                                                Σύντομη Περιγραφή/Παρατηρήσεις
                                            </MDTypography>
                                        </MDBox>
                                        <MDEditor
                                            value={description || ""}
                                            onChange={(e) => handleInputChange("description", e)}
                                            readOnly={!isEditing}
                                        />
                                    </Grid>

                                    {/* Buttons */}
                                    <Grid mt={3} item xs={12}>
                                        <MDBox
                                            display="flex"
                                            justifyContent="space-between"
                                            alignItems="center"
                                        >
                                            {/* Left side: Delete */}
                                            <MDButton
                                            variant="outlined"
                                            color="secondary"
                                            onClick={() => navigate("/list/accidents")}
                                            sx={{ "&.MuiButton-outlined": { textTransform: "capitalize !important" } }}
                                            >
                                            Ακύρωση
                                            </MDButton>


                                        </MDBox>
                                    </Grid>
                                </Grid>
                            </MDBox>
                        </Card>
                    </Grid>

                    {/* Map */}
                    <Grid item xs={12} md={7}>
                        <div className="mapContainer100">
                            <MapSelect
                                selectedPoint={position} // [lon, lat]
                                setSelectedPoint={setPosition}
                                isEditing={isEditing}
                            />
                        </div>
                    </Grid>

                    {successSB && bringSuccessNotification()}
                    {errorSB && bringErrorNotification()}
                </Grid>

                {/* Delete confirmation dialog */}
                <Dialog open={openDeleteDialog} onClose={handleDeleteCancel}>
                    <DialogTitle style={{color:"black"}}>Επιβεβαίωση Διαγραφής</DialogTitle>
                    <DialogContent>
                        <MDTypography color={"black"}>
                            Είστε σίγουρος ότι θέλετε να διαγράψετε αυτό το ατύχημα;
                        </MDTypography>
                    </DialogContent>
                    <DialogActions>
                        <MDButton onClick={handleDeleteCancel} color="secondary">
                            Ακύρωση
                        </MDButton>
                        <MDButton onClick={handleDeleteConfirmed} color="error">
                            Διαγραφή
                        </MDButton>
                    </DialogActions>
                </Dialog>
            </MDBox>
        </DashboardLayout>
    );
};

export default AccidentDetails;
